// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1FKoU","info":"UpdateTermsInfo_info__1vF4z"};